import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const VACATION_HOME = {
  nickname: 'PRODUCTS.VACATION_HOME.shortname',
  LIST_OF_OBJECTS: ['houseWithContents', 'houseAdditionalBuildings'],
  properties: [
    {
      name: 'objectAddress', key: 'OBJECT_ADDRESS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'objectZipCode', key: 'OBJECT_ZIP_CODE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern('[0-9]{4}$')
      ]]
    },
    { name: 'houseSumInsuredType', key: 'SUM_INSURED_TYPE', group: 'INSURANCE_INFO' },
    { name: 'houseSurgeProtectionInFuseCabinet', key: 'HOUSE_SURGE_PROTECTION_IN_FUSE_CABINET', group: 'OBJECT_INFO' },
    { name: 'houseRotAndAnimalDamage', key: 'HOUSE_ROT_AND_ANIMAL_DAMAGE', group: 'INSURANCE_INFO' },
    { name: 'houseSMPipeInPipe', key: 'HOUSE_SM_PIPE_IN_PIPE', group: 'OBJECT_INFO' },
    {
      name: 'houseSMAlarmConnected', key: 'HOUSE_SM_ALARM_CONNECTED', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseSMFireAlarm', key: 'HOUSE_SM_FIRE_ALARM', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseSMBurglarAlarm', key: 'HOUSE_SM_BURGAR_ALARM', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseBuildingMaterials', key: 'BUILDING_MATERIALS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.WOOD', value: 'WOOD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.CONCRETE', value: 'CONCRETE' },
        ]
      }
    },
    {
      name: 'houseWithContents', key: 'HOUSE_WITH_CONTENTS', group: 'INSURANCE_INFO',
      values: [
        {
          name: 'contentsCover',
          key: 'CONTENTS_COVER',
        },
        {
          name: 'productPackage',
          key: 'HOUSE_CONTENT_PRODUCT_PACKAGE',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.INNBO', value: 'STANDARD' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.INNBO_MAKS', value: 'SUPER' }
            ]
          }
        },
        {
          name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.3', value: '3000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.5', value: '5000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.7', value: '7000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.10', value: '10000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.15', value: '15000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.20', value: '20000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.25', value: '25000' }
            ]
          }
        },
        {
          name: 'productSumInsured', key: 'HOUSE_CONTENT_SUM_INSURED', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.TEL,
          validator: ['', [
            Validators.required
          ]],
        }
      ]
    },
    {
      name: 'houseAdditionalBuildings', key: 'HOUSE_ADDITIONAL_BUILDINGS', group: 'OBJECT_INFO',
      values: [
        {
          name: 'houseBuildingType',
          key: 'BUILDING_TYPE',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.SHED_NOT_ISOLATED_KLP', value: 'SHED_NOT_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.SHED_ISOLATED_KLP', value: 'SHED_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.GARAGE_ISOLATED', value: 'GARAGE_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.GARAGE_NOT_ISOLATED', value: 'GARAGE_NOT_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.CARPORT', value: 'CARPORT' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.OUTBUILDING_WITH_LIVING_AREA',
                 value: 'OUTBUILDING_WITH_LIVING_AREA'},
            ]
          }
        },
        {
          name: 'houseBuildingStandard', key: 'BUILDING_STANDARD', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.NORMAL', value: 'NORMAL' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.BETTER', value: 'BETTER' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.HIGH', value: 'HIGH' },
            ]
          }
        },
        // {
        //   name: 'houseNumberOfBathrooms', key: 'HOUSE_NUMBER_OF_BATHROOMS', group: 'OBJECT_INFO',
        //   inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
        //   validator: ['', [
        //     Validators.required
        //   ]],
        //   settings: {
        //     list: [
        //       { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.N0_BADS', value: '0' },
        //       { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.1_BAD', value: '1' },
        //       { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.2_BADS', value: '2' },
        //       { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.3_AND_MORE_BADS', value: '3' },
        //     ]
        //   }
        // },
        {
          name: 'houseBuildingYear', key: 'BUILDING_YEAR', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.DATE,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            dateView: 'multi-years'
          }
        },
        // {
        //   name: 'houseSMNoCella', key: 'HOUSE_SM_NO_CELLA', group: 'OBJECT_INFO',
        //   inputType: INPUT_TYPES_CONFIG.BOOLEAN,
        //   validator: ['', [
        //     Validators.required
        //   ]]
        // },
        {
          name: 'houseSMFlatRoof', key: 'HOUSE_SM_FLAT_ROOF', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.BOOLEAN,
          validator: ['', [
            Validators.required
          ]]
        },
        // {
        //   name: 'buildingPermanentlyInhabited', key: 'BUILDING_PARMANENTLY_INHABITED', group: 'INSURANCE_INFO',
        //   inputType: INPUT_TYPES_CONFIG.BOOLEAN,
        //   validator: ['', [
        //     Validators.required
        //   ]]
        // },
        {
          name: 'houseSMAlarmBurglar', key: 'HOUSE_SM_ALARM_BURGAR', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.BOOLEAN,
          validator: ['', [
            Validators.required
          ]]
        },
        {
          name: 'houseBuildingHasPower', key: 'HOUSE_BUILDING_HAS_POWER', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.BOOLEAN,
          validator: ['', [
            Validators.required
          ]]
        },
        {
          name: 'houseSMAlarmCentral', key: 'HOUSE_SM_ALARM_CENTRAL', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.BOOLEAN,
          validator: ['', [
            Validators.required
          ]]
        },
        {
          name: 'houseBuildingHasWater', key: 'HOUSE_BUILDING_HAS_WATER', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.BOOLEAN,
          validator: ['', [
            Validators.required
          ]]
        },
        {
          name: 'houseSquareMeters', key: 'SQUARE_METERS', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.NUMBER,
          validator: ['', [
            Validators.required
          ]]
        },
        {
          name: 'houseMaintenance', key: 'BUILDING_MAINTENANCE', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MAINTENANCE.NORMAL', value: 'NORMAL' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MAINTENANCE.NOTGODD', value: 'POOR' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MAINTENANCE.UPGRADE', value: 'UPGRADE' },
            ]
          }
        },
        {
          name: 'houseSMFireAlarmConnected', key: 'HOUSE_SM_FIRE_ALARM_CONNECTED_KLP', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.BOOLEAN,
          validator: ['', [
            Validators.required
          ]]
        },
        {
          name: 'propertyBuildingNumber', key: 'PROPERTY_BUILDING_NUMBER', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.STRING,
          validator: ['']
        },
      ]
    },
    {
      name: 'houseBuildingYear', key: 'BUILDING_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    {
      name: 'houseSMElectricalControl', key: 'HOUSE_SM_ELECTRICAL_CONTROL', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseBuildingHasPower', key: 'HOUSE_BUILDING_HAS_POWER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseBuildingHasWater', key: 'HOUSE_BUILDING_HAS_WATER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseBuildingStandard', key: 'BUILDING_STANDARD', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.NORMAL', value: 'NORMAL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.BETTER', value: 'BETTER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.HIGH', value: 'HIGH' },
        ]
      }
    },
    {
      name: 'houseMaintenance', key: 'BUILDING_MAINTENANCE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MAINTENANCE.NORMAL', value: 'NORMAL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MAINTENANCE.NOTGODD', value: 'POOR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MAINTENANCE.UPGRADE', value: 'UPGRADE' },
        ]
      }
    },
    {
      name: 'houseBuildingType',
      key: 'BUILDING_TYPE',
      group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.VACATION_HOME', value: 'VACATION_HOME' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.CABIN', value: 'CABIN' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.CABIN_SMALL', value: 'CABIN_SMALL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.VACATION_HOME_TOWNHOUSE', value: 'VACATION_HOME_TOWNHOUSE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.CARPORT', value: 'CARPORT' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.GARAGE_ISOLATED', value: 'GARAGE_ISOLATED' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.GARAGE_NOT_ISOLATED', value: 'GARAGE_NOT_ISOLATED' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.OUTBUILDING_WITH_LIVING_AREA', value: 'OUTBUILDING_WITH_LIVING_AREA'},
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.SHED_ISOLATED', value: 'SHED_ISOLATED' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.SHED_NOT_ISOLATED', value: 'SHED_NOT_ISOLATED' }
        ]
      }
    },
    {
      name: 'houseSquareMeters', key: 'SQUARE_METERS', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseIsRented', key: 'HOUSE_IS_RENTED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      isRentalPeriodCheck: true,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'rentalPeriod', key: 'RENTAL_PERIOD', group: 'INSURANCE_INFO',
    },
    {
      name: 'houseSMAutomaticWaterStop', key: 'HOUSE_SM_AUTOMATIC_WATER_STOP', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      isHouseDamagesCheck: true,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.VACATION_HOME', value: 'STANDARD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.VACATION_HOME_EXTENDED', value: 'STANDARD_INC_ROT' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.VACATION_HOME_MAKS', value: 'SUPER' }
        ]
      }
    },
    { name: 'moistureOrWaterDamage', key: 'MOISURE_OR_WATER_DAMAGE', group: 'INSURANCE_INFO', },
    { name: 'deficienciesOrErrorsOrDamages', key: 'DEFICIENCIES_OR_ERROR_OR_DAMAGES', group: 'INSURANCE_INFO', },
    {
      name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.3', value: '3000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.5', value: '5000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.7', value: '7000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.10', value: '10000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.15', value: '15000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.20', value: '20000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.25', value: '25000' }
        ]
      }
    },
    {
      name: 'propertyFarmNumber', key: 'PROPERTY_FARM_NUMBER', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['']
    },
    {
      name: 'propertyUserNumber', key: 'PROPERTY_USER_NUMBER', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['']
    },
    {
      name: 'propertyBuildingNumber', key: 'PROPERTY_BUILDING_NUMBER', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['']
    },
    { name: 'houseSMAutomaticCircuitBreaker', key: 'HOUSE_SM_AUTOMATIC_CIRCUIT_BREAKER', group: 'OBJECT_INFO' },
    { name: 'houseSMFlatRoof', key: 'HOUSE_SM_FLAT_ROOF', group: 'OBJECT_INFO' },
    { name: 'houseStandardCategory', key: 'HOUSE_STANDARD_CATEGORY', group: 'OBJECT_INFO' },
    { name: 'houseNumberOfBathrooms', key: 'HOUSE_NUMBER_OF_BATHROOMS', group: 'OBJECT_INFO' },
    { name: 'houseSM300FromRoad', key: 'HOUSE_SM_FROM_ROAD', group: 'OBJECT_INFO' },
    { name: 'houseSMhasLowBasement', key: 'HOUSE_SM_HAS_LOW_BASEMENT', group: 'OBJECT_INFO' },
    { name: 'houseSMElectricalControl', key: 'HOUSE_SM_ELECTRICAL_CONTROL', group: 'OBJECT_INFO' },
    { name: 'houseSMBehindLockedRoadBarrier', key: 'HOUSE_SM_BEHIND_LOCKED_ROAD_BARRIER', group: 'OBJECT_INFO' },
  ],
  icon:'vacation-home'
};
